import * as THREE from 'three';
import gsap from "gsap";

export let camera;
export let cameraState = "main";

export const SetupCamera = (scene, sizes) => {
    camera = new THREE.PerspectiveCamera(
        13.5,
        sizes.width / sizes.height,
        0.1,
        1000);
    camera.position.set(-0.13493567705154408, 5.4965717792510977, 5.6436157226562482);
    camera.lookAt({ x: -0.009703266434371471, y: 0.20406365394592285, z: 0.13180576264858246 });
    scene.add(camera);

    // const cameraHelper = new THREE.CameraHelper(camera);
    // scene.add(cameraHelper);
    return camera;
};

export const AnimateCamera = (startPos, endPos, lookAtTarget, duration = 1, ease = "power2.inOut", Complete = null) => {
    gsap.to(startPos, {
        x: endPos.x,
        y: endPos.y,
        z: endPos.z,
        duration: duration,
        ease: ease,
        onUpdate: () => {
            camera.position.set(startPos.x, startPos.y, startPos.z);
            camera.lookAt(lookAtTarget.x, lookAtTarget.y, lookAtTarget.z);
        },
        onComplete: () => {
            // console.log("Camera animation complete!");
            // console.log(`pos : ${camera.position.x}, ${camera.position.y}, ${camera.position.z}`);
            // console.log(`rot : ${camera.rotation.x}, ${camera.rotation.y}, ${camera.rotation.z}`);
            Complete();
        }
    });
};

const AnimateCameraFov = (camera, _startValue, _endValue, _duration = 1) => {
    const startTime = performance.now();

    const animate = (currentTime) => {
        const elapsedTime = (currentTime - startTime) / 1000; // 초 단위 시간
        const t = Math.min(elapsedTime / _duration, 1); // 보간 값 (0 ~ 1)
        // 선형 보간
        camera.fov = THREE.MathUtils.lerp(_startValue, _endValue, t);
        camera.updateProjectionMatrix();

        // 애니메이션 종료 여부 확인
        if (t < 1) {
            // console.log(value);
            requestAnimationFrame(animate);
        } else {
            console.log("Camera animation complete!");
        }
    };

    requestAnimationFrame(animate);
}

export const GetCameraInfo = (scene, camera, controls) => {
    const direction = new THREE.Vector3();
    camera.getWorldDirection(direction)
    if (controls)
        console.log(`target : ${controls.target.x}, ${controls.target.y}, ${controls.target.z}`);
    console.log(`world direction : ${direction.x}, ${direction.y}, ${direction.z}`);
    console.log(`pos : `, camera.position);
    console.log(`rot : `, camera.rotation);

    const cam = scene.getObjectByName('null_cam');
    const aim = scene.getObjectByName('null_aim');
    console.log('cam :', cam.position);
    console.log('aim :', aim.position);
}

export const setMoveToCamera = (moveTo = "about", duration = 0.5, ease = "power2.inOut") => {
    var newCameraPosition, newCameraRotation;
    cameraState = moveTo;
    if (moveTo === "about" || moveTo === "work" || moveTo === "contact") {
        newCameraPosition = new THREE.Vector3(-0.1568, 0.87512, 1.8641);
        newCameraRotation = new THREE.Vector3(-0.4236, -0.0797, -0.0359);
    } else if (moveTo === "main") {
        newCameraPosition = new THREE.Vector3(0, 1.2, 1.8);
        newCameraRotation = new THREE.Vector3(-0.5167, 0, 0);
    }

    // 포지션 tween
    gsap.to(camera.position, {
        duration: duration,
        x: newCameraPosition.x,
        y: newCameraPosition.y,
        z: newCameraPosition.z,
        ease: ease,
        onUpdate: () => {
            // 만약 lookAt을 계속 업데이트 하고 싶다면 아래 주석을 해제하세요.
            // camera.lookAt(newLookAtTarget.x, newLookAtTarget.y, newLookAtTarget.z);
        },
        onComplete: () => {
            console.log("Camera moved to sub position");
        }
    });

    // 로테이션 tween (Euler 각도를 tweening 합니다)
    gsap.to(camera.rotation, {
        duration: duration,
        x: newCameraRotation.x,
        y: newCameraRotation.y,
        z: newCameraRotation.z,
        ease: ease,
        onComplete: () => {
            console.log("Camera rotation complete");
        }
    });
};

export const setMoveToCameraNull = (scene, camPos, aimPos, duration) => {
    const cam = scene.getObjectByName('null_cam');
    const aim = scene.getObjectByName('null_aim');

    if (!cam || !aim) return;

    gsap.to(cam.position, {
        x: camPos.x,
        y: camPos.y,
        z: camPos.z,
        duration: duration,
        ease: 'power2.in'
    });
    gsap.to(aim.position, {
        x: aimPos.x,
        y: aimPos.y,
        z: aimPos.z,
        duration: duration,
        ease: 'power2.in'
    })
}